import {
  AndroidNotification,
  IOSNotification,
  handlePushNotificationReceived,
  pushNotificationRegisterError,
} from './PushNotificationActions';

import { Api } from './Api';
import { PushProviderTypeEnum } from '@pdcplan/shared/enums';
import { ThunkDispatch } from '../types';
import { isCordovaApp } from '@pdcshell/helpers/utils';
import getApi from '../getApi';

export type PushNotificationData = {
  title: string;
  message: string;
};

export function enablePushNotifications(dispatch: ThunkDispatch) {
  if (isCordovaApp()) {
    window.pdc.shell?.emit('push-enable');
    const api = getApi();
    setupPushNotifications(api, dispatch);
  }
}

/**
 * Call this method to set up push notifications for the current device.
 * This should be called after the 'onload' and 'deviceready' events have fired.
 */
export function setupPushNotifications(api: Api, dispatch: ThunkDispatch) {
  const shell = window.pdc.shell;
  if (!shell?.on) {
    throw new Error('Need window.pdc.shell to be an eventemitter!');
  }

  shell.removeAllListeners('push-token-refresh');

  shell.on('push-token-refresh', (deviceRegistrationId: string) => {
    if (!deviceRegistrationId) {
      console.warn('No deviceId, not sending registerDevice');
      return;
    }
    api
      .registerDevice(deviceRegistrationId, PushProviderTypeEnum.fcm)
      .catch((err) => {
        dispatch(pushNotificationRegisterError(err));
      });
  });

  shell.on(
    'push-notification',
    (data: AndroidNotification | IOSNotification) => {
      dispatch(handlePushNotificationReceived(data));
    }
  );
}

